var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2566 22.2503H8.73656C3.82656 22.2503 1.72656 20.1503 1.72656 15.2403V15.1103C1.72656 10.6703 3.47656 8.53027 7.39656 8.16027C7.79656 8.13027 8.17656 8.43027 8.21656 8.84027C8.25656 9.25027 7.95656 9.62027 7.53656 9.66027C4.39656 9.95027 3.22656 11.4303 3.22656 15.1203V15.2503C3.22656 19.3203 4.66656 20.7603 8.73656 20.7603H15.2566C19.3266 20.7603 20.7666 19.3203 20.7666 15.2503V15.1203C20.7666 11.4103 19.5766 9.93027 16.3766 9.66027C15.9666 9.62027 15.6566 9.26027 15.6966 8.85027C15.7366 8.44027 16.0866 8.13027 16.5066 8.17027C20.4866 8.51027 22.2666 10.6603 22.2666 15.1303V15.2603C22.2666 20.1503 20.1666 22.2503 15.2566 22.2503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.63C11.59 15.63 11.25 15.29 11.25 14.88V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V14.88C12.75 15.3 12.41 15.63 12 15.63Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0038 16.7498C11.8138 16.7498 11.6238 16.6798 11.4738 16.5298L8.12375 13.1798C7.83375 12.8898 7.83375 12.4098 8.12375 12.1198C8.41375 11.8298 8.89375 11.8298 9.18375 12.1198L12.0038 14.9398L14.8238 12.1198C15.1137 11.8298 15.5938 11.8298 15.8838 12.1198C16.1738 12.4098 16.1738 12.8898 15.8838 13.1798L12.5338 16.5298C12.3837 16.6798 12.1938 16.7498 12.0038 16.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.2ba100cfe0b7bf5d76ef8f9e364c4d61.svg";
export { ForwardRef as ReactComponent };